"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = require("../../../../tasks/constants");
const TaskPage_1 = require("../../base/TaskPage");
const autosave_1 = require("../../../../hooks/autosave");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const RadioQuestion_1 = require("../../../components/input/radio/RadioQuestion");
const Section_1 = require("../../../components/section/Section");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const bookingNoticeOptions = {
    '1 day': 1,
    '2 days': 2,
    '3 days': 3,
    '7 days': 7,
};
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [bookingNoticeValue, setBookingNoticeValue] = React.useState();
    // We performed a data migration to stop customers having values not in the accepted list, but let's be defensive against
    // this anyway.
    React.useEffect(() => {
        if (!!property && property.advance_bookings !== undefined) {
            if (!Object.values(bookingNoticeOptions).includes(property.advance_bookings)) {
                console.log(`Advance booking value (${property.advance_bookings}) not in list of accepted values, defaulting to 2 nights`);
                bookingNoticeUpdate(2);
            }
            else {
                setBookingNoticeValue(property.advance_bookings);
            }
        }
    }, [property === null || property === void 0 ? void 0 : property.advance_bookings]);
    const bookingNoticeUpdate = (newValue) => {
        update({ advance_bookings: newValue });
        setBookingNoticeValue(newValue);
    };
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.BOOKING_NOTICE, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, null,
            React.createElement(TaskPage_1.TaskColumn, { width: 50 },
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(Section_1.Section, { heading: "Guest arrivals" },
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(RadioQuestion_1.RadioQuestion, { selected: bookingNoticeValue, id: "booking-notice", question: "How much notice do you need before a guest arrives?", options: bookingNoticeOptions, onChange: (_, v) => bookingNoticeUpdate(v) }),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'advance-notice', text: React.createElement("div", null,
                            "Guests are able to book your property until midnight of the day you have selected. Please note you may be notified on the day of arrival if you have selected 1 day arrival notice. For more information on booking notice, read ",
                            React.createElement("a", { href: "https://travelnest.freshdesk.com/support/solutions/articles/101000396985-booking-notice-period-explained" }, "this guide"),
                            ".") }))))));
};
//# sourceMappingURL=BookingNoticePage.js.map